<template>
	<div class="angle-selector" >
		<div class="circle" ref="circle" @click="circleClicked">
			<div class="c-pointer"
			     @mousedown="mousedownHandle"
			     :style="{'transform':`rotate(${closeWise?angle:-angle}deg)`}">
				<div class="c-center"></div>
				<div class="c-line"></div>
			</div>
		</div>
<!--		<p>{{angle}}°</p>-->
	</div>
</template>

<script>
import {getAngle} from './angle'

export default {
	name: 'angle-selector',
	data() {
		return {
		}
	},
	props: {
		angle: {
			type: Number
		},
		closeWise: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		getCenterPos() {
			let domRect = this.$refs['circle'].getBoundingClientRect()
			return {
				x: domRect.width / 2 + domRect.x,
				y: domRect.height / 2 + domRect.y
			}
		},
		circleClicked(e) {
			const centerPos = this.getCenterPos()

			let angle = getAngle(centerPos.x, centerPos.y, e.clientX, e.clientY, this.closeWise)
			console.log("angle", angle);
			this.$emit('change', angle)
		},
		mousedownHandle(e) {
			const centerPos = this.getCenterPos()

			let angle = getAngle(centerPos.x, centerPos.y, e.clientX, e.clientY, this.closeWise)
			this.$emit('change', angle)

			let mouseMove = (e) => {
				let angle = getAngle(centerPos.x, centerPos.y, e.clientX, e.clientY, this.closeWise)
				this.$emit('change', angle)
			}
			let mouseUp = (e) => {

				document.body.removeEventListener('mousemove', mouseMove)
				document.body.removeEventListener('mouseup', mouseUp)
			}
			document.body.addEventListener('mousemove', mouseMove)
			document.body.addEventListener('mouseup', mouseUp)
		}
	}
}
</script>

<style scoped lang="scss">
.angle-selector {
	width: 70px;
	text-align: center;
}

.circle {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 2px solid $grey;
	position: relative;
}

.c-center {
	height: 4px;
	width: 4px;
	position: absolute;
	background: $blue;
	border-radius: 50%;
}

.c-pointer {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 50%;
	margin: -2px 0 0 -2px;
	transform-origin: 2px 2px;
}

.c-line {
	position: relative;
	margin-top: 1.5px;
	margin-right: -2px;
	height: 1px;
	background: $blue;
	&:after {
		content: '';
		width: 8px;
		height: 8px;
		display: block;
		background: white;
		position: absolute;
		left: 100%;
		margin-left: -4px;
		margin-top: -4px;
		border-radius: 50%;
		box-shadow: 0 0 0 2px $sharp-blue;
	}
}
</style>
